import { Context, createContext, useContext } from "react";
import AuthService from "../api/auth-service";

const authContext: Context<AuthService> = createContext(new AuthService());

export default function useAuth(): AuthService {
    return useContext(authContext);
}